<div class="d-flex">
  <div class="main-wrapper" ngbDropdown #dateRangeDrop="ngbDropdown" placement="bottom-right">
    <button class="btn btn-outline-secondary date-range-btn" ngbDropdownToggle>
      {{ dateRangeText }}
    </button>
    <div class="date-range-container" ngbDropdownMenu>
      <div class="row px-2">
        <div class="col-6">
          <div class="relative-date-btn">
            <button
              class="btn btn-outline-secondary"
              [ngClass]="{ active: internalDateRange === 'THIS_YEAR' }"
              (click)="onRange(dateRangeEnum.THIS_YEAR)"
            >
              This year
            </button>
          </div>
        </div>
        <div class="col-6">
          <div class="relative-date-btn">
            <button
              class="btn btn-outline-secondary"
              [ngClass]="{ active: internalDateRange === 'LAST_WEEK' }"
              (click)="onRange(dateRangeEnum.LAST_WEEK)"
            >
              Last week
            </button>
          </div>
        </div>
      </div>
      <div class="row px-2">
        <div class="col-6">
          <div class="relative-date-btn">
            <button
              class="btn btn-outline-secondary"
              [ngClass]="{ active: internalDateRange === 'LAST_2_MONTH' }"
              (click)="onRange(dateRangeEnum.LAST_2_MONTH)"
            >
              Last month
            </button>
          </div>
        </div>
        <div class="col-6">
          <div class="relative-date-btn">
            <button
              class="btn btn-outline-secondary"
              [ngClass]="{ active: internalDateRange === 'LAST_YEAR' }"
              (click)="onRange(dateRangeEnum.LAST_YEAR)"
            >
              Last year
            </button>
          </div>
        </div>
      </div>
      <hr />
      <form *ngIf="form" [formGroup]="form" novalidate (submit)="onSubmit()">
        <div class="row px-2">
          <div class="col-6">
            <div class="mb-3">
              <label class="form-label" for="startDate"> Start date </label>
              <div class="input-group">
                <input
                  class="form-control"
                  style="margin-right: 5px"
                  id="startDate"
                  ngbDatepicker
                  #dpStartDate="ngbDatepicker"
                  maxlength="12"
                  formControlName="startDate"
                  [maxDate]="maxDateStart"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-sm btn-transparent btn-icon"
                    (click)="dpStartDate.toggle()"
                    type="button"
                  >
                    <i class="material-icons mi-18">date_range</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="form-label" for="endDate"> End date </label>
              <div class="input-group">
                <input
                  class="form-control"
                  id="endDate"
                  ngbDatepicker
                  #dpEndDate="ngbDatepicker"
                  maxlength="12"
                  formControlName="endDate"
                  [minDate]="minDateEnd"
                  [maxDate]="maxDateEnd"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-sm btn-transparent btn-icon"
                    (click)="dpEndDate.toggle()"
                    type="button"
                  >
                    <i class="material-icons mi-18">date_range</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-12 mb-3">
            <button
              type="submit"
              *ngFor="let range of previousRanges"
              class="btn btn-outline-secondary btn-sm mb-1 col-12 justify-content-center"
              (click)="onPreviousRangeClick(range)"
            >
              {{ range.fromDate }} to {{ range.toDate }}
            </button>
          </div>
        </div>
        <div class="action-buttons">
          <button type="button" class="btn btn-transparent btn-reset" (click)="onReset()">
            Reset
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Apply</button>
        </div>
      </form>
    </div>
  </div>
</div>
